import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import label from "../../../common/labels/common_en.json";
import { uploadTransactionalData, getAllTransactionalDataTypes, downloadSampleCSVFile, uploadDataByUsingCron, getFileUploadStatus, downloadErrorCSVFile, getAdvertisementlistByYear, getYearList, uploadTransactionalAnswerKeyData } from "../../../common/actions/commonActions";
import { DatePicker, Space } from 'antd';
import dayjs from "dayjs";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { SET_FILE_UPLOAD_STATUS } from "../../../common/constants/ActionTypes";
import { getExamslistByAdvertisementId, getSubjectlistByExamId } from "../../actions/postExaminationProcessObjectiveActions";


function TransactionalDataImport() {
  const dateFormat = 'YYYY/MM/DD';
  let formattedDate = '';
  const { register, handleSubmit, errors, setValue, reset, formState } = useForm({
    mode: "onChange",
  });

  const fileInputRef = useRef(null);

  const [selectedUploadFile, setSelectedUploadFile] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [allTypes, setAllTypes] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [typeId, setTypeId] = useState("");
  const [isAnswerKeyUpload, setIsAnswerKeyUpload] = useState(false)

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedAdvertisementId, setSelectedAdvertisementId] = useState("");
  const [fileName, setFileName] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAllTransactionalDataTypes());
    dispatch({
      payload: {},
      type: SET_FILE_UPLOAD_STATUS,
    });

    dispatch(getYearList());
  }, []);

  let { transactionalDataTypes, fileUploadStatus, yearList, allYearList } = useSelector((state) => state.common, shallowEqual);
  let { examList, subjectList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  useEffect(() => {
    setAllTypes(transactionalDataTypes);
  }, [transactionalDataTypes]);
  useEffect(() => { }, [reloadItem]);

  function formatDate(inputDateString) {
    const inputDate = new Date(inputDateString);

    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');

    const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }

  const handleClearFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const onTypeChange = (ele) => {
    let selType = ele;
    setSelectedType(selType);
    let getSelDate = allTypes.find(item => item.type === ele);
    let getIsAnswerKeyData = allTypes.find(item => item.type === ele);
    getSelDate && setSelectedDate(getSelDate.updateDataAfter !== null ? formatDate(getSelDate.updateDataAfter) : "");
    const type = allTypes.find(type => type.type === selType);
    dispatch(getFileUploadStatus(type.id));
    setIsAnswerKeyUpload(getIsAnswerKeyData.flgUploadCsv ? true : false);
    setTypeId(type.id);
    setReloadItem(!reloadItem);
  };
  const onChange = (value, dateString) => {
    if (dateString) {
      setSelectedDate(dateString)
    } else {
      setSelectedDate("")
    }
  };

  const onSubmit = () => {
    setIsUploading(true);
    // RESET PREVIOUS FILE UPLOAD STATUS  
    dispatch({
      payload: {},
      type: SET_FILE_UPLOAD_STATUS,
    });

    if (selectedExam !== '' && selectedAdvertNo !== '') {
      let data = {};
      data.file = selectedUploadFile;
      data.type = "importData";
      const selectedSubjectObj = subjectList.find(
        item => String(item.id) === String(selectedSubject)
      );

      // if (
      //   selectedSubjectObj &&
      //   selectedSubjectObj.type?.toUpperCase() === "DESCRIPTIVE"
      // ) {
      //   const uploadTypeMessage =
      //     selectedType?.toUpperCase().includes("KEY")
      //       ? "Answer Key"
      //       : "Answer Sheet";

      //   toastr.error(
      //     `${uploadTypeMessage} upload is not allowed for Descriptive subjects.`
      //   );

      //   return;
      // }
      dispatch(uploadTransactionalAnswerKeyData(
        selectedType,
        data,
        setSelectedType,
        selectedDate,
        selectedExam,
        selectedSubject,
        selectedAdvertisementId,
        handleClearFile
      ));
      onCancelButton();

    } else {

      if (selectedUploadFile && selectedUploadFile.size > label.FILE_SIZE_LIMIT * 1024 * 1024) {

        toastr.warning(label.FileSizeExceeds, label.FileIsBeingUploaded);
        let data = {};
        data.file = selectedUploadFile;
        data.csvUploadConfigId = typeId;
        dispatch(uploadDataByUsingCron(data, selectedDate, handleClearFile));
        onCancelButton();

      } else {

        let data = {};
        data.file = selectedUploadFile;
        data.type = "importData";
        dispatch(uploadTransactionalData(
          selectedType,
          data,
          setSelectedType,
          selectedDate,
          selectedAdvertNo,
          handleClearFile
        ));
        onCancelButton();
      }
    }

    handleClearFile();
  };
  useEffect(() => {
    let interval;

    if (isUploading && typeId) {
      interval = setInterval(() => {
        dispatch(getFileUploadStatus(typeId));
      }, 5000); // every 5 seconds
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isUploading, typeId]);

  useEffect(() => {
    if (
      isUploading &&
      fileUploadStatus?.fileUploadStatusDtos?.length > 0
    ) {
      const latestFile =
        fileUploadStatus.fileUploadStatusDtos[0];

      if (latestFile.status === "COMPLETED") {
        setIsUploading(false);

        if (latestFile.flgErrorCsv) {
          toastr.error(
            "Answer Sheet upload is not allowed for Descriptive subjects."
          );
        } else {
          toastr.success("Upload Completed");
        }
      }

      if (latestFile.status === "FAILED") {
        setIsUploading(false);
        toastr.error("Upload Failed");
      }
    }
  }, [fileUploadStatus, isUploading]);


  const handleSampleDownload = (type) => {
    dispatch(downloadSampleCSVFile(type));
  };

  const handleErrorCSV = (type, id, date) => {
    dispatch(downloadErrorCSVFile(type, id, date));
  };

  const onCancelButton = () => {
    setSelectedUploadFile("");
    reset();
    setSelectedDate("");
    setSelectedType("");
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setTypeId("");
    dispatch({
      payload: {},
      type: SET_FILE_UPLOAD_STATUS,
    });
    setSaveButtonFlag(true);
  };


  const onUploadFileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    let fileName = e.target.files[0].name;
    setFileName(fileName);
    setSaveButtonFlag(false);
    let selectedValue = e.target.files[0];
    setSelectedUploadFile(selectedValue);
    setReloadItem(!reloadItem);
  };


  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0
    }
    if (examList) {
      examList.length = 0;
    }
    if (subjectList) {
      subjectList.length = 0
    }
    // reset();
    setSaveButtonFlag(true);

    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    setSelectedAdvertisementId(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    setSelectedExam("");
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    subjectList.length = 0;
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    setSaveButtonFlag(false);
    // onSubmit(selectedValue);
    setReloadItem(!reloadItem);
    // setEditedValues({});
  };

  useEffect(() => {
    register(
      { name: "selectedUploadFile" },
      {
        required: true,
        validate: {
          validType: (value) => {
            if (!value || value.length === 0) return false;

            const allowed = ["xlsx", "xls", "csv"];
            const ext = value[0].name.split(".").pop().toLowerCase();
            return allowed.includes(ext) || "Invalid file type";
          }
        }
      }
    );
  }, [fileInputRef?.current?.value]);

  return (
    <div className="commonContentArea">
      <h5> {label.TransactionalDataCsvImport} </h5>
      {/* {isUploading && (
        <div className="text-center mt-3 mb-3">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Processing...</span>
          </div>
          <p className="mt-2">
            Processing large file... Please wait until database insertion completes.
          </p>
        </div>
      )} */}
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data" onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group importFromSection">
              <div className="row">

                {/* <div className="col-md-2" >
                  <label className="float-left w-100">
                    Select Date
                    <span className="errorText">*</span>
                  </label>
                  <DatePicker defaultValue={dayjs('2023-08-04T00:00:00.000+00:00', dateFormat)} format={dateFormat} />
                </div> */}
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectType}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedType"
                    // value={selectedType}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onTypeChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {label.COMBO_SELECT}
                    </option>
                    {allTypes &&
                      allTypes.length > 0 &&
                      allTypes.map((element, index) => (
                        <option key={index} value={element.type}>
                          {element.name}
                          {element.examType ? ` (${element.examType.toUpperCase()})` : ""}
                          {/* ({element.examType?.toUpperCase()}) */}
                        </option>
                      ))}
                  </select>
                  {_.get("selectedType.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                {isAnswerKeyUpload && <><div className="form-group col-md-2">
                  <label className="float-left">
                    {label.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {label.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {label.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                  <div className="form-group col-md-4">
                    <label className="float-left">
                      {label.SelectAdvertNo}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedAdvertiseNo"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onAdvertisementChange(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {label.COMBO_SELECT}
                      </option>
                      {allYearList &&
                        allYearList.length > 0 &&
                        allYearList
                          .filter(
                            (element) =>
                              element.isDeleted == false &&
                              element.isActive === true
                          )
                          .map((element, index) => (
                            <option key={index} value={element.id}>
                              {`${element.advertisementNo}/${element.year} - ${element.name}`}
                            </option>
                          ))}
                    </select>
                    {_.get("selectedAdvertiseNo.type", errors) ===
                      "required" && (
                        <p className="errorText float-left">
                          {label.MANDATORY_FIELD_MESSAGE}
                        </p>
                      )}
                  </div>

                  <div className=" col-md-3">
                    <label className="float-left">
                      {label.SelectExam}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedExam"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onExamChange(e.target.value);
                      }}
                    >
                      <option key={0} value="" >
                        {label.COMBO_SELECT}
                      </option>
                      {
                        examList &&
                        examList.length > 0 &&
                        examList
                          .filter(
                            (element) =>
                              element.isDeleted == false &&
                              element.isActive === true
                          )
                          .map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))
                      }
                    </select>
                    {_.get("selectedExam.type", errors) === "required" && (
                      <p className="errorText float-left">
                        {label.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>

                  <div className=" col-md-3">
                    <label className="float-left">
                      {label.SelectSubject}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedSubject"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onSubjectChange(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {label.COMBO_SELECT}
                      </option>
                      {
                        subjectList &&
                        subjectList.length > 0 &&
                        subjectList
                          // .filter(
                          //   (element) =>
                          //     element.isDeleted == false &&
                          //     element.isActive === true
                          // )
                          .map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name} ({element.type?.toUpperCase()})
                            </option>
                          ))
                      }
                    </select>
                    {_.get("selectedSubject.type", errors) === "required" && (
                      <p className="errorText float-left">
                        {label.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>
                </>}

                <div className="form-group col-md-3">
                  <label className="float-left">
                    Update Data From Date
                  </label>
                  <Space className="w-100" direction="vertical">
                    <DatePicker
                      className="w-100"
                      allowClear
                      showTime={{
                        format: 'HH:mm',
                      }}
                      format="YYYY/MM/DD HH:mm"
                      value={selectedDate && dayjs(selectedDate, 'YYYY/MM/DD HH:mm')}
                      onChange={onChange}
                    />
                  </Space>
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectUploadFile}
                    <span className="errorText">*</span>
                  </label>
                  {/* <input
                    className="form-control"
                    type="file"
                    ref={fileInputRef}
                    accept=".xlsx, .xls, .csv"
                    name="selectedUploadFile"
                    onChange={(e) => {
                      onUploadFileChange(e);
                    }}
                  />
                  {_.get("selectedUploadFile.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )} */}
                  <input
                    className="form-control"
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    ref={(el) => (fileInputRef.current = el)}
                    onChange={(e) => {
                      setValue("selectedUploadFile", e.target.files, { shouldValidate: true });
                      onUploadFileChange(e);
                    }}
                  />
                  {errors.selectedUploadFile?.type === "required" && (
                    <p className="errorText float-left">{label.MANDATORY_FIELD_MESSAGE}</p>
                  )}

                  {errors.selectedUploadFile?.type === "validType" && (
                    <p className="errorText float-left">
                      Only .xlsx, .xls, .csv files are allowed
                    </p>
                  )}
                </div>

                <div className="form-group col-md-6 mt-3 d-flex align-items-center">
                  <button
                    type="reset"
                    className="btn btn-secondary mr-2"
                    onClick={() => onCancelButton()}
                  >
                    {label.BUTTON_CANCEL}
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!formState.isValid}
                  // onClick={handleSubmit((e) => {
                  //   onSubmit(e);
                  //   handleClearFile();

                  // })}
                  >
                    {label.BUTTON_IMPORT}
                  </button>
                  <div className="float-right">
                    <i
                      className={"fa fa-file-excel-o ml-2 fa-2x text-success"}
                      aria-hidden="true"
                      onClick={() => {
                        if (selectedType !== "") {
                          handleSampleDownload(selectedType);
                        }
                      }}
                      style={{ cursor: selectedType === "" ? "not-allowed" : "pointer" }}
                      title={selectedType === "" ? label.SELECTTYPE : label.DOWNLOADTEMPLATE}                    ></i>
                  </div>
                </div>

                {selectedType && fileUploadStatus && fileUploadStatus.fileUploadStatusDtos && fileUploadStatus.fileUploadStatusDtos.length > 0 && (
                  <div className="form-group col-md-12">
                    <h5>File Upload Status</h5>
                    <table className="table table-bordered text-center">
                      <thead className="bold-label">
                        <tr>
                          <th>{label.SrNo}</th>
                          <th>{label.TYPE}</th>
                          <th>{label.STATUS}</th>
                          <th>{label.UPLOADEDDATE}</th>
                          <th>{label.NOOFRECORDSADDED}</th>
                          <th>{label.ERRORFILE}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fileUploadStatus && fileUploadStatus.fileUploadStatusDtos.map((statusObj, index) => (
                          <React.Fragment key={index}>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{statusObj.type}</td>
                              <td>{statusObj.status}</td>
                              <td>{moment(statusObj.updateDateAfter).format('DD/MM/YYYY HH:mm:ss')}</td>
                              <td>{statusObj.noOfRecords || 0}</td>
                              <td>
                                {statusObj.flgErrorCsv === true ? (
                                  <i
                                    className={"fa fa-file-excel-o ml-2 fa-2x text-success"}
                                    aria-hidden="true"
                                    onClick={() => {
                                      if (selectedType !== "") {
                                        handleErrorCSV(selectedType, statusObj.id, statusObj.updateDateAfter);
                                      }
                                    }}
                                    style={{ cursor: selectedType === "" ? "not-allowed" : "pointer" }}
                                    title={selectedType === "" ? label.SELECTTYPE : label.DOWNLOADERRORFILE}
                                  ></i>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>)}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TransactionalDataImport;
